
import * as types from '../actions/actionTypes'
import { assign } from 'lodash'

const initialState = {
  boxesList:[{
    id: 1,
    name: '',
    length: 0,
    width: 0,
    height: 0,
    boxWeight: 0,
    weightLimit: 0,
    weightAvailable: 0,
    approved: false,
  }]
}

function boxes(state = initialState, action) {
  switch (action.type) {
    case types.BOXES_FETCH_SUCCESS:
        return assign({}, state, {
          boxesList: action.res,
        })
    case types.BOX_SET_SUCCESS:
      return assign({}, state, action.res)
    case types.BOX_FETCH_SUCCESS:
      console.log('ACTION RES', action.res)
    case types.BOX_EDIT_SUCCESS:
      return assign({}, state, {
        box: action.res,
      });
    case types.BOX_DELETE_SUCCESS:
      return assign({}, state, {
        boxDelete: action.res.ok,
      });
    case types.BOX_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    case types.BOXES_FETCH_ERROR:
    case types.BOX_SET_ERROR:
    case types.BOX_FETCH_ERROR:
    case types.BOX_EDIT_ERROR:
    case types.BOX_DELETE_ERROR:
        console.log('BOX ERROR')
        return assign({}, state, {
          error: action.res,
        })
    default:
    return state;
  }
}

export default boxes 


// WEBPACK FOOTER //
// ./src/reducers/boxes.js